import React, { useCallback, useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import PropTypes from "prop-types";
import { Row, Col, Form, Space, Input, Spin, Collapse, Tooltip } from "antd";
import { MinusSquareFilled, PlusSquareFilled } from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { getRequest, patchRequest, postRequest } from "../../axios";
import { SuccessNotificationMsg } from "../../utils/Notifications";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { Breadcrumb } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import InputField from "../../common/htmlComponents/InputField";
import { authUserData } from "../../utils/Helper";
import { debounce } from "lodash";
import _ from "lodash";

const EmailForNotificationRFQ = ({ VendorId, setKeyPersonId }) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const { Panel } = Collapse;
  const navigate = useNavigate();
  const employee = authUserData()?.company
    ? authUserData()?.role[0].name.includes("company_")
    : null;
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;

  const initialState = {
    buyer_company_email: [
      {
        company: null,
        person_name: null,
        designation: null,
        email: null,
        phone_number: null,
      },
    ],

    vendors_email: [
      {
        name: "",
        vendor_persons: [
          {
            person_name: null,
            email: null,
            designation: null,
            phone_number: null,
          },
        ],
      },

      // {
      //   name: 'Reliance',
      //   persons: [
      //     {
      //       person_name: null,
      //       email: null,
      //       designation: null,
      //       phone_number: null,
      //     }
      //   ]
      // }
    ],
  };

  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setApiLoading] = useState(false);
  const [vendor, setVendor] = useState(null);
  const [buyerCompany, setBuyerCompany] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [getApi, setGetApi] = useState(false);
  const [buyerId, setBuyerId] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  const [vendorIds, setVendorIds] = useState([]);
  const [rfqNumber, setRfqNumber] = useState(null);
  const [email, setEmail] = useState("");
  const [res, setRes] = useState(null);

  const { rfqDetailFloatID, rfqId } = useParams();

  useEffect(() => {
    const getEmailRfq = async () => {
      setApiLoading(true);
      try {
        const apiResponse = await getRequest(
          `float-rfq/${rfqDetailFloatID}/company-email-for-notifications/`
        );
        // 382
        console.log("apiResponse", apiResponse);
        if (apiResponse.data.success) {
          //setState(apiResponse.data.data)

          apiResponse?.data?.data?.map((buyer) => {
            buyer?.buyer_company_email?.map((buyer) => {
              if (buyer.id !== null || buyer.id !== undefined) {
                setBuyerId(buyer.id);
              }
            });
          });

          apiResponse?.data?.data.map((vendor) => {
            // setState(vendor.vendor_emails); // Assuming vendor_emails is an array and you want to update the vendor state with it
            // console.log("ddddd ", vendor); // Logging vendor_emails for debugging

            vendor?.vendor_emails?.map((ven) => {
              if (
                ven.vendor_persons[0].id !== null ||
                ven.vendor_persons[0].id !== undefined
              ) {
                // console.log('ven.vendor_persons[0].id ' ,ven.vendor_persons[0].id);
                setVendorId(ven.vendor_persons[0].id);
              }
            });
            const vendors = apiResponse.data.data;
            const ids = vendors
              .map((vendor) => {
                return vendor.vendor_emails.map((ven) => ven.vendor);
              })
              .flat();
            setVendorIds(ids.filter((id) => id !== null && id !== undefined));

            // const {

            //   id,

            //   ...filteredResponse
            // } = apiResponse.data.data;
            setState((prevState) => ({
              ...prevState,
              buyer_company_email: vendor.buyer_company_email.map(
                (innerIndex) => {
                  const buyerCompanyEmail = {
                    company: CompanyId,
                    person_name: innerIndex.person_name,
                    email: innerIndex.email,
                    designation: innerIndex.designation,
                    phone_number: innerIndex.phone_number,
                  };
                  if (innerIndex.id !== null) {
                    buyerCompanyEmail.id = innerIndex.id;
                  }
                  return buyerCompanyEmail;
                }
              ),
              // vendors_email:
              vendors_email: vendor.vendor_emails.map((vendor) => ({
                vendor: vendor.vendor,
                vendor_name: vendor.vendor_name,
                vendor_persons: vendor.vendor_persons.map((person) => {
                  const payloadPerson = {
                    person_name:
                      person.person_name === null ? null : person.person_name,
                    email: person.email === null ? null : person.email,
                    designation:
                      person.designation === null ? null : person.designation,
                    phone_number:
                      person.phone_number === null ? null : person.phone_number,
                  };
                  if (person.id !== null) {
                    payloadPerson.id = person.id;
                  }
                  return payloadPerson;
                }),
              })),
            }));
          });

          setWeightSizeFieldValueBuyer(
            apiResponse.data.data[0].buyer_company_email
          );
          const modifiedVendors = apiResponse.data.data.flatMap((vendor) => {
            console.log("vend ", vendor);
            return vendor.vendor_emails.map((ven) => {
              return ven;
            });
          });
          setRfqNumber(apiResponse.data.data[0].rfq_number);
          console.log("modifiedVendors ", modifiedVendors);

          setWeightSizeFieldValue(modifiedVendors);

          const modifiedVendorsBuyers = apiResponse.data.data.flatMap(
            (vendor) => {
              return vendor.buyer_company_email;
            }
          );

          setWeightSizeFieldValueBuyer(modifiedVendorsBuyers);
        } else {
          // ErrorNotificationMsg(t("err_getSubscription"));
        }

        // if (CompanyId !== null) {

        // }

        setApiLoading(false);
      } catch (error) {
        setApiLoading(false);
      }
    };
    getEmailRfq();
  }, [CompanyId, buyerId, vendorId, getApi]);

  // const handleSubmit = async () => {
  //   try {
  //     setBtnLoading(true);
  //     const response = await patchRequest(
  //       `vendor-vendors_email/${VendorId}/`,
  //       state
  //     );
  //     if (response.data.success) {
  //       SuccessNotificationMsg(t("keyperson_updated_successfully"));
  //       setKeyPersonId(response.data.data.vendors_email[0].id);
  //       setBtnLoading(false);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     setBtnLoading(false);
  //   }
  // };

  console.log("buyerId ", buyerId);
  console.log("vendorId ", vendorId);

  // const debounceFetchData = async (
  //   value,
  //   fieldName,
  //   outerIndex,
  //   innerIndex
  // ) => {
  //   try {
  //     setApiLoading(true);
  //     const apiResponse = await getRequest(
  //       `float-rfq/23/company-email-for-notifications=${value}`
  //     );

  //     // if (apiResponse.data.results.data.length > 0) {
  //     //   const {
  //     //     pincode_name,
  //     //     unique_code,
  //     //     // vendor_company_data,
  //     //     id,
  //     //     company_payment_terms,
  //     //     keypersons,
  //     //     bankdetails,
  //     //     assgin_site,
  //     //     inquiry_value,
  //     //     ...filteredResponse
  //     //   } = apiResponse.data.results.data[0];
  //     //   // const {
  //     //   //   unique_code,
  //     //   //   id,
  //     //   //   company_payment_terms,
  //     //   //   keypersons,
  //     //   //   bankdetails,
  //     //   //   assgin_site,
  //     //   //   inquiry_value,
  //     //   //   ...filteredResponse
  //     //   // } = apiResponse.data.data;
  //     //   setapiloading(false);
  //     //   setgstVendorId(apiResponse.data.results.data[0].id);
  //     //   setPostGeneratedVendorId(null);
  //     // }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      // let payloadPerson = [];
      const payload = {
        buyer_company_email:
          state.buyer_company_email &&
          state.buyer_company_email.every(
            (person) =>
              person.person_name === null &&
              person.email === null &&
              person.designation === null &&
              person.phone_number === null
          )
            ? []
            : state.buyer_company_email,

        vendors_email: state.vendors_email
          .map((vendor) => ({
            vendor: vendor.vendor,
            vendor_persons: vendor.vendor_persons.map((person) => ({
              person_name:
                person.person_name === null ? null : person.person_name,
              email: person.email === null ? null : person.email,
              designation:
                person.designation === null ? null : person.designation,
              phone_number:
                person.phone_number === null ? null : person.phone_number,
            })),
          }))

          // vendors_email: state.vendors_email
          //   .map((vendor) => ({
          //     vendor: vendor.vendor,
          //     vendor_persons: vendor.vendor_persons.map((person) => {
          //       payloadPerson = {
          //         person_name:
          //           person.person_name === null ? null : person.person_name,
          //         email: person.email === null ? null : person.email,
          //         designation:
          //           person.designation === null ? null : person.designation,
          //         phone_number:
          //           person.phone_number === null ? null : person.phone_number,
          //       };
          //       if (person.id !== null) {
          //         payloadPerson.id = person.id;
          //       }
          //       return payloadPerson;
          //     }),
          //   }))
          .every(
            (vendor) =>
              // vendor.name === ""
              vendor.vendor === null &&
              vendor.vendor_persons.every(
                (person) =>
                  person.person_name === null &&
                  person.email === null &&
                  person.designation === null &&
                  person.phone_number === null
              )
          )
          ? []
          : state.vendors_email,
      };

      let response;
      // if (CompanyId === null) {

      if (buyerId === null && vendorId === null) {
        response = await postRequest("verify-email-notifications/", payload);
      } else {
        response = await patchRequest(
          `verify-email-notifications/${CompanyId}/`,
          payload
        );
      }

      if (response.data.success) {
        SuccessNotificationMsg(t("Save as Draft"));
        setSubmitted(true);

        // apiResponse?.data?.data?.map((buyer) => {
        //   buyer?.buyer_company_email?.map((buyer) => {
        //     if(buyer.id !== null || buyer.id !== undefined){
        //       setBuyerId(buyer.id)
        //     }
        //   })
        // })
        // setGetApi();
        console.log("after success notification msg");
        setGetApi((prevState) => !prevState);

        console.log("after setGetAPi");

        // response.data.data.company_emails.map((item) => {
        //   console.log('poco');
        //   item.buyer_company_email.map((buyer) => {
        //     if (buyer.id !== null || buyer.id !== undefined) {
        //       console.log('buyer12 ');
        //       setBuyerId(buyer.id);
        //     }
        //   });
        // });

        console.log("after response.data.data in buyer company");

        // response.data.data.company_emails.map((item) => {
        //   item.vendor_emails.map((ven) => {
        //     if (
        //       ven.vendor_persons[0].id !== null ||
        //       ven.vendor_persons[0].id !== undefined
        //     ) {
        //       setVendorId(ven.vendor_persons[0].id);
        //     }
        //   });
        // });

        console.log("after response.data.data in vendor_emails");

        // SuccessNotificationMsg(
        //   buyerId === null && vendorId === null
        //     ? t("email_notified")
        //     : t("email_notified")
        // );

        // setState(initialState);
        // formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        // navigate("/company");
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };
  const setWeightSizeFieldValue = (data) => {
    let fieldObject = {};
    data?.map((outerObj, outerIndex) => {
      console.log("outerObj ", outerObj);
      outerObj?.vendor_persons.map((innerObj, innerIndex) => {
        fieldObject[`person_name${outerIndex}${innerIndex}`] =
          innerObj.person_name;
        fieldObject[`email${outerIndex}${innerIndex}`] = innerObj.email;
        fieldObject[`designation${outerIndex}${innerIndex}`] =
          innerObj.designation;
        fieldObject[`phone_number${outerIndex}${innerIndex}`] = String(
          innerObj.phone_number || "+91"
        );
      });
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  const setWeightSizeFieldValueBuyer = (data) => {
    console.log("45445 ", data);

    let fieldObject = {};
    data?.map((outerObj, outerIndex) => {
      console.log("outerObj ", outerObj);
      fieldObject[`person_name${outerIndex}`] = outerObj.person_name;
      fieldObject[`email${outerIndex}`] = outerObj.email;
      fieldObject[`designation${outerIndex}`] = outerObj.designation;
      fieldObject[`phone_number${outerIndex}`] = String(
        outerObj.phone_number || "+91"
      );
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  // const setWeightSizeFieldValue = (data) => {
  //   console.log('data5454 ', data);
  //   let fieldObject = {};
  //   data?.forEach((outerObj, outerIndex) => {
  //     if (outerObj.vendor_persons && Array.isArray(outerObj.vendor_persons)) {
  //       outerObj.vendor_persons.forEach((innerObj, innerIndex) => {
  //         fieldObject[`person_name${outerIndex}${innerIndex}`] = innerObj.person_name;
  //         fieldObject[`email${outerIndex}${innerIndex}`] = innerObj.email;
  //         fieldObject[`designation${outerIndex}${innerIndex}`] = innerObj.designation;
  //         fieldObject[`phone_number${outerIndex}${innerIndex}`] = String(innerObj.phone_number || "+91");
  //       });
  //     }
  //   });
  //   formRef.current.setFieldsValue(fieldObject);
  // };

  const debouncedFetchDataBuyer = useCallback(
    debounce(async (value, fieldName, outerIndex, venId) => {
      console.log("venId 22", venId);
      setApiLoading(true);
      try {
        if (value !== "" && fieldName === "email") {
          // setApiLoading(true);
          const apiResponse = await getRequest(
            `verify-email-notifications/employee-by-login-company/?email=${value}`
          );
          console.log("apiResponse 99 BUYER ", apiResponse);

          const responseData = apiResponse.data.data[0];
          // console.log('responseData 89', responseData);

          setState((prevState) => {
            const newState = { ...prevState };

            const responseData = apiResponse.data.data[0];

            // state.vendors_email[outerIndex].vendor_persons[innerIndex]
            // if(state.vendors_email[outerIndex].vendor_persons[innerIndex]){
            // }

            if (responseData) {
              newState.buyer_company_email[outerIndex] = {
                company: CompanyId,
                designation: responseData.designation,
                email: responseData.email,
                person_name: responseData.first_name,
                phone_number: responseData.phone,
              };
            }

            //             // const { name, email, designation, phone_number } = responseData;
            //             // console.log('data 5', responseData);

            //             // Assuming outerIndex is defined elsewhere in your code
            const newBuyerEmails = [...newState.buyer_company_email];
            newState.buyer_company_email = newBuyerEmails;
            //             // // Assuming vendor_persons is an array inside vendors_email at the index outerIndex
            let newVendorEmailsEmpty = {
              person_name: "",
              email: "",
              designation: "",
              phone_number: "",
            };

            // setState((prevState) => ({
            //     ...prevState,
            //     vendors_email: newVendorEmails,
            // }))

            // console.log('newVendorEmails ', newVendorEmails);

            //           // const modifiedVendor = state.vendors_email

            setWeightSizeFieldValueBuyer(newBuyerEmails);

            return newState;
          });

          // state.buyer_company_email[outerIndex] = {

          //   company:CompanyId,
          //   designation: responseData.designation,
          //   email: responseData.email,
          //   person_name: responseData.first_name,
          //   phone_number: responseData.phone
          // };

          // const newBuyerEmails = [...state.buyer_company_email];

          // setState((prevState) => ({
          //     ...prevState,
          //     buyer_company_email: newBuyerEmails,
          // }))

          //   setWeightSizeFieldValueBuyer(newBuyerEmails);

          // const modifiedVendors = newVendorEmails.flatMap((vendor) => {
          //   console.log("vend ", vendor);
          //   return vendor.vendor_emails.map((ven) => {
          //     return ven;
          //   });
          // });
          // console.log("modifiedVendors 555 ", modifiedVendors);
        }
        setApiLoading(false);
      } catch (error) {
        setApiLoading(false);
        console.error("Error fetching vendor details:", error);
      }
    }, 1200),
    []
  );
  useEffect(() => {
    return () => {
      debouncedFetchDataBuyer.cancel();
    };
  }, [debouncedFetchDataBuyer]);

  // const debouncedFetchData = _.debounce(
  //   async (value, fieldName, outerIndex, innerIndex, venId) => {
  //     console.log('value 69 ', value)
  //     // onTypeEmail(value); // Call onTypeEmail with the latest value
  //     console.log('in debouncedFetchData');
  //     console.log('state11 ', state.vendors_email[outerIndex].vendor_persons[innerIndex]);
  //     try {
  //       if (value !== "" && fieldName === 'email') {
  //         // setApiLoading(true);
  //         const apiResponse = await getRequest(
  //           // `verify-email-notifications/employee-by-company-mail/?email=${value}`
  //           `vendor-communication-matrix/${venId}/communication-matrix-by-vendor?email=${value}`
  //         );
  //         console.log('apiResponse 99 ', apiResponse);
  //         // Handle API response...

  //         const responseData = apiResponse.data.data[0];
  //         console.log('responseData 89', responseData);

  //         // state.vendors_email[outerIndex].vendor_persons[innerIndex]
  //         state.vendors_email[outerIndex].vendor_persons[innerIndex] = {
  //           designation: responseData.designation,
  //           email: responseData.email,
  //           person_name: responseData.name,
  //           phone_number: responseData.phone_number
  //       };

  //             // const { name, email, designation, phone_number } = responseData;
  //             // console.log('data 5', responseData);

  //             // Assuming outerIndex is defined elsewhere in your code
  //             const newVendorEmails = [...state.vendors_email];

  //             // // Assuming vendor_persons is an array inside vendors_email at the index outerIndex
  //             let newVendorEmailsEmpty=({
  //                 person_name: '',
  //                 email: '',
  //                 designation: '',
  //                 phone_number: '',
  //             });

  //           // if(responseData !== [])
  //           // {
  //             setState((prevState) => ({
  //                 ...prevState,
  //                 vendors_email: newVendorEmails,
  //             }))
  //           // }
  //           // else{
  //           //   setState((prevState) => ({
  //           //     ...prevState,
  //           //     vendors_email: newVendorEmailsE
  //           //   }))
  //           // }

  //           // const modifiedVendor = state.vendors_email
  //           setWeightSizeFieldValue(newVendorEmails);

  //           const modifiedVendors = newVendorEmails.flatMap((vendor) => {
  //             console.log("vend ", vendor);
  //             return vendor.vendor_emails.map((ven) => {
  //               return ven;
  //             });
  //           });
  //           // setRfqNumber(apiResponse.data.data[0].rfq_number);
  //           console.log("modifiedVendors 555 ", modifiedVendors);

  //           // setWeightSizeFieldValue(modifiedVendors);
  //       }
  //     } catch (error) {
  //       setApiLoading(false);
  //       // console.error("Error fetching vendor details:", error);
  //     }
  //   },
  //   1000
  // );

  const debouncedFetchData = useCallback(
    debounce(async (value, fieldName, outerIndex, innerIndex, venId) => {
      setApiLoading(true);

      try {
        if (value !== "" && fieldName === "email") {
          const apiResponse = await getRequest(
            // `verify-email-notifications/employee-by-company-mail/?email=${value}`
            `vendor-communication-matrix/${venId}/communication-matrix-by-vendor?email=${value}`
          );
          setRes(apiResponse);

          setState((prevState) => {
            const newState = { ...prevState };

            const responseData = apiResponse.data.data[0];

            // state.vendors_email[outerIndex].vendor_persons[innerIndex]
            // if(state.vendors_email[outerIndex].vendor_persons[innerIndex]){
            // }

            if (responseData) {
              newState.vendors_email[outerIndex].vendor_persons[innerIndex] = {
                designation: responseData.designation,
                email: responseData.email,
                person_name: responseData.name,
                phone_number: responseData.phone_number,
              };
            }

            //             // const { name, email, designation, phone_number } = responseData;
            //             // console.log('data 5', responseData);

            //             // Assuming outerIndex is defined elsewhere in your code
            const newVendorEmails = [...newState.vendors_email];
            newState.vendors_email = newVendorEmails;
            //             // // Assuming vendor_persons is an array inside vendors_email at the index outerIndex
            let newVendorEmailsEmpty = {
              person_name: "",
              email: "",
              designation: "",
              phone_number: "",
            };

            // setState((prevState) => ({
            //     ...prevState,
            //     vendors_email: newVendorEmails,
            // }))

            console.log("newVendorEmails ", newVendorEmails);

            //           // const modifiedVendor = state.vendors_email

            setWeightSizeFieldValue(newVendorEmails);

            return newState;
          });

          // const modifiedVendors = newVendorEmails.flatMap((vendor) => {
          //   console.log("vend ", vendor);
          //   return vendor.vendor_emails.map((ven) => {
          //     return ven;
          //   });
          // });
          //           // setRfqNumber(apiResponse.data.data[0].rfq_number);
          // console.log("modifiedVendors 555 ", modifiedVendors);

          // setWeightSizeFieldValue(modifiedVendors);
        }
        setApiLoading(false);
      } catch (error) {
        console.error("Error fetching vendor details:", error);
        setApiLoading(false);
      }
    }, 1200),
    []
  );

  useEffect(() => {
    return () => {
      debouncedFetchData.cancel();
    };
  }, [debouncedFetchData]);

  const handleChange = (value, fieldName, outerIndex, innerIndex, venId) => {
    console.log(
      "fieldName ",
      fieldName,
      "outerIndex ",
      outerIndex,
      "innerIndex ",
      innerIndex
    );
    const updatedVendors = state.vendors_email.map((item, index) => {
      if (index === outerIndex) {
        const updatedPersons = item.vendor_persons.map(
          (person, personIndex) => {
            if (personIndex === innerIndex) {
              return { ...person, [fieldName]: value };
            }
            return person;
          }
        );
        return { ...item, vendor_persons: updatedPersons };
      }
      return item;
    });
    // setVendor(updatedVendors);
    setState((prevState) => ({
      ...prevState,
      vendors_email: updatedVendors,
    }));

    debouncedFetchData(value, fieldName, outerIndex, innerIndex, venId);
  };

  // const onTypeEmail = (value) => {
  //   // setState({
  //   //   ...state,
  //   //   email: value,
  //   // });

  //   setEmail(value);
  // };

  // const handleChangeBuyer = (field, e, outerIndex) => {
  //   let newPersonArr = buyerCompany;
  //   newPersonArr[outerIndex][field] = e.target.value ? e.target.value : null;
  //   setBuyerCompany({ ...buyerCompany, buyer_company_email: newPersonArr });
  // };
  const handleChangeBuyer = (field, e, outerIndex, venId) => {
    console.log(" pppp", venId);
    let value = e.target.value;
    let newPersonArr = state.buyer_company_email;
    newPersonArr[outerIndex][field] = e.target.value ? e.target.value : null;
    setState({ ...state, buyer_company_email: newPersonArr });

    debouncedFetchDataBuyer(value, field, outerIndex, venId);
  };

  //   const handleChange = (value, fieldName, outerIndex, innerIndex) => {
  //     console.log('fieldName ', fieldName, 'value ', value, 'outerIndex ', outerIndex, 'innerIndex ', innerIndex);
  //     const updatedVendors = vendor.map((vendorItem, index) => {
  //         if (index === outerIndex) {
  //             const updatedPersons = vendorItem.vendor_persons.map((person, personIndex) => {
  //                 if (personIndex === innerIndex) {
  //                     console.log('person 1 ', person);
  //                     return { ...person, [fieldName]: value };
  //                 }
  //                 console.log('person11111 ', person);
  //                 return person;
  //             });
  //             return { ...vendorItem, vendor_persons: updatedPersons };
  //         }
  //         return vendorItem;
  //       });
  //       console.log('updatedVendors ', updatedVendors);
  //     setVendor(updatedVendors)

  // };

  const addPerson = (outerIndex) => {
    const newVendorEmails = [...state.vendors_email];
    newVendorEmails[outerIndex].vendor_persons.push({
      person_name: null,
      email: null,
      designation: null,
      phone_number: null,
    });
    // setVendor(newVendorEmails);
    // setState(newVendorEmails);
    setState((prevState) => ({
      ...prevState,
      vendors_email: newVendorEmails,
    }));
    setWeightSizeFieldValue(newVendorEmails);
  };

  const addPersonBuyer = () => {
    const newPersonArr = [
      ...state.buyer_company_email,
      {
        company: CompanyId,
        person_name: null,
        email: null,
        designation: null,
        phone_number: null,
      },
    ];
    setState({ ...state, buyer_company_email: newPersonArr });
    setWeightSizeFieldValueBuyer(newPersonArr);
  };

  // const addPerson = (outerIndex) => {
  //   // Make sure vendor at the specified outerIndex exists
  //   if (vendor && vendor[outerIndex] && vendor[outerIndex].vendor_persons) {
  //     const newVendorPersons = [...vendor[outerIndex].vendor_persons];
  //     newVendorPersons.push({
  //       person_name: null,
  //       email: null,
  //       designation: null,
  //       phone_number: null,
  //     });

  //     const updatedVendor = { ...vendor[outerIndex], vendor_persons: newVendorPersons };

  //     const newVendorArray = [...vendor];
  //     newVendorArray[outerIndex] = updatedVendor;

  //     setVendor({ ...vendor, vendors_email: newVendorArray });
  //     setWeightSizeFieldValue(newVendorArray);
  //   }
  // };

  const removePerson = (outerIndex, innerIndex) => {
    if (
      state.vendors_email &&
      state.vendors_email[outerIndex] &&
      state.vendors_email[outerIndex].vendor_persons
    ) {
      const newVendorPersons = [
        ...state.vendors_email[outerIndex].vendor_persons,
      ];
      newVendorPersons.splice(innerIndex, 1);
      const updatedVendor = {
        ...state.vendors_email[outerIndex],
        vendor_persons: newVendorPersons,
      };
      const newVendorArray = [...state.vendors_email];
      newVendorArray[outerIndex] = updatedVendor;
      // setVendor(newVendorArray);
      // setState((prevState)=>{...prevState,newVendorArray)};
      setState((prevState) => ({
        ...prevState,
        vendors_email: newVendorArray,
      }));
      setWeightSizeFieldValue(newVendorArray);
    }
  };

  const removePersonBuyer = async (lastIndex) => {
    let filterPersonArr = state.buyer_company_email.filter(
      (item, outerIndex) => outerIndex !== lastIndex
    );
    setState({ ...state, buyer_company_email: filterPersonArr });
    // setBuyerCompany({ ...buyerCompany, buyer_company_email: filterPersonArr });
    setWeightSizeFieldValueBuyer(filterPersonArr);
  };

  const handleClonePhoneInputChange = (field, phone, outerIndex) => {
    let newPersonArr = state.buyer_company_email;
    newPersonArr[outerIndex][field] = phone ? phone : null;
    setState({ ...state, buyer_company_email: newPersonArr });
  };

  const handleSendRfqApproval = async () => {
    try {
      setBtnLoading(true);
      // let payloadPerson = [];
      const payload = {
        buyer_company_email:
          state.buyer_company_email &&
          state.buyer_company_email.every(
            (person) =>
              person.person_name === null &&
              person.email === null &&
              person.designation === null &&
              person.phone_number === null
          )
            ? []
            : state.buyer_company_email,

        vendors_email: state.vendors_email
          .map((vendor) => ({
            vendor: vendor.vendor,
            vendor_persons: vendor.vendor_persons.map((person) => ({
              person_name:
                person.person_name === null ? null : person.person_name,
              email: person.email === null ? null : person.email,
              designation:
                person.designation === null ? null : person.designation,
              phone_number:
                person.phone_number === null ? null : person.phone_number,
            })),
          }))
          .every(
            (vendor) =>
              // vendor.name === ""
              vendor.vendor === null &&
              vendor.vendor_persons.every(
                (person) =>
                  person.person_name === null &&
                  person.email === null &&
                  person.designation === null &&
                  person.phone_number === null
              )
          )
          ? []
          : state.vendors_email,
      };

      let response;
      // if (CompanyId === null) {
      response = await patchRequest(
        `float-rfq/${rfqDetailFloatID}/rfq-send-for-approval/`,
        payload
      );
      // SuccessNotificationMsg(response.data.message);
      navigate(`/request-for-quotation/history`);
    } catch (error) {
      setBtnLoading(false);
    }
  };

  const handleDirectRelease = async () => {
    try {
      setBtnLoading(true);
      // let payloadPerson = [];
      const payload = {
        buyer_company_email:
          state.buyer_company_email &&
          state.buyer_company_email.every(
            (person) =>
              person.person_name === null &&
              person.email === null &&
              person.designation === null &&
              person.phone_number === null
          )
            ? []
            : state.buyer_company_email,

        vendors_email: state.vendors_email
          .map((vendor) => ({
            vendor: vendor.vendor,
            vendor_persons: vendor.vendor_persons.map((person) => ({
              person_name:
                person.person_name === null ? null : person.person_name,
              email: person.email === null ? null : person.email,
              designation:
                person.designation === null ? null : person.designation,
              phone_number:
                person.phone_number === null ? null : person.phone_number,
            })),
          }))
          .every(
            (vendor) =>
              // vendor.name === ""
              vendor.vendor === null &&
              vendor.vendor_persons.every(
                (person) =>
                  person.person_name === null &&
                  person.email === null &&
                  person.designation === null &&
                  person.phone_number === null
              )
          )
          ? []
          : state.vendors_email,
      };

      let response;
      // if (CompanyId === null) {
      response = await patchRequest(
        `float-rfq/${rfqDetailFloatID}/rfq-release/`,
        payload
      );
      SuccessNotificationMsg(response.data.message);
      navigate(`/request-for-quotation/history`);
    } catch (error) {
      setBtnLoading(false);
    }
  };

  console.log("buyer ", buyerCompany);

  console.log("state 222", state);
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Verify and manage email notifications for different stages of
                  the RFQ process, including Inquiry, Offer, and Order. Ensure
                  timely and accurate communication with vendors and
                  stakeholders.
                </span>
              }
            >
              <h3>{t("verifyEmail")}</h3>
            </Tooltip>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/SelectVendor"> {t("addRFQBreadcrumb")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("verifyEmailBreadcrumb")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <section className="grid-sec FormSection Container">
        <div className="FormBody">
          <Spin spinning={apiLoading}>
            <Row gutter={16}>
              <Col className="TextFeild gutter-row">
                <label
                  className="cp"
                  style={{ paddingTop: "10px", display: "block" }}
                >
                  RFQ Number
                </label>
              </Col>
              <Col className="TextFeild gutter-row">
                <InputField readOnly name="" placeholder={rfqNumber} />
              </Col>
            </Row>
            <Form onFinish={handleSubmit} autoComplete="off" ref={formRef}>
              <>
                {/* <Collapse defaultActiveKey={[1]} key={1}>
                  <Panel header={"Buyer Company Approver"} key={1}>
                    {state.buyer_company_email &&
                      state.buyer_company_email.map((outerObj, outerIndex) => (
                        <div key={outerIndex}>
                          <Row
                            key={outerIndex}
                            className="customcol"
                            gutter={[15]}
                          >
                            <Col
                              xs={24}
                              sm={24}
                              md={12}
                              lg={4}
                              xl={4}
                              className="TextFeild gutter-row"
                            >
                              <Form.Item
                                name={`email` + outerIndex}
                                label={outerIndex === 0 ? t("pl_email") : ""}
                                rules={[
                                  {
                                    type: "email",
                                    message: <Trans>{t("val_email")}</Trans>,
                                  },
                                ]}
                              >
                                <Input
                                  className="cust-input"
                                  placeholder={t("pl_email")}
                                  onChange={(value) =>
                                    handleChangeBuyer("email", value, outerIndex, outerObj.company)
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              xs={24}
                              sm={24}
                              md={12}
                              lg={4}
                              xl={4}
                              className="TextFeild gutter-row"
                            >
                              <Form.Item
                                name={`person_name` + outerIndex}
                                label={outerIndex === 0 ? t("pl_personName") : ""}
                                rules={[
                                  {
                                    required: false,
                                    message: <Trans>{t("pl_gst")}</Trans>,
                                  },
                                  {
                                    pattern: /^[a-zA-Z_ ]+$/,
                                    message: "Enter Valid Name",
                                  },
                                  {
                                    min: 2,
                                    message: <Trans>{t("minlength_msg")}</Trans>,
                                  },
                                  {
                                    max: 15,
                                    message: (
                                      <Trans>{t("maxlength_personName")}</Trans>
                                    ),
                                  },
                                ]}
                              >
                                <Input
                                  className="cust-input"
                                  placeholder={t("pl_personName")}
                                  onChange={(value) =>
                                    handleChangeBuyer(
                                      "person_name",
                                      value,
                                      outerIndex
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              xs={24}
                              sm={24}
                              md={12}
                              lg={4}
                              xl={4}
                              className="TextFeild gutter-row"
                            >
                              <Form.Item
                                name={`designation` + outerIndex}
                                label={outerIndex === 0 ? t("pl_designation") : ""}
                                rules={[
                                  {
                                    min: 3,
                                    message: <Trans>{t("minlength_msg")}</Trans>,
                                  },
                                  {
                                    max: 30,
                                    message: (
                                      <Trans>{t("maxlength_designation")}</Trans>
                                    ),
                                  },
                                ]}
                              >
                                <Input
                                  className="cust-input"
                                  placeholder={t("pl_designation")}
                                  onChange={(value) =>
                                    handleChangeBuyer(
                                      "designation",
                                      value,
                                      outerIndex,

                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>

                            <Col
                              xs={24}
                              sm={24}
                              md={12}
                              lg={4}
                              xl={4}
                              className="TextFeild gutter-row"
                            >
                              <Form.Item
                                name={`phone_number` + outerIndex}
                                label={outerIndex === 0 ? t("pl_ContactNo") : ""}
                                rules={[
                                  {
                                    message: <Trans>{t("val_phone")}</Trans>,
                                  },
                                ]}
                              >
                                <PhoneInput
                                  className="PhoneSection"
                                  country={"in"}
                                  // onChange={(phone) =>
                                  //   handleChangeBuyer(
                                  //     "phone_number",
                                  //     phone,
                                  //     outerIndex
                                  //   )
                                  // }
                                  onChange={(phone) =>
                                    handleClonePhoneInputChange(
                                      "phone_number",
                                      phone,
                                      outerIndex
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            {outerIndex === 0 ? (
                              <Col
                                xs={24}
                                sm={24}
                                md={12}
                                lg={4}
                                xl={4}
                                className="TextFeild addrowkeyperson"

                              >
                                <div className="addwrp">
                                  <Space>

                                    <PlusSquareFilled
                                      className="add"
                                      onClick={(e) => addPersonBuyer(outerIndex)}
                                    />



                                  </Space>
                                </div>
                              </Col>
                            ) : (
                              <Col
                                xs={24}
                                sm={24}
                                md={12}
                                lg={4}
                                xl={4}
                                className="TextFeild addrowkeyperson"
                                style={{ paddingTop: "0px" }}
                              >
                                <div className="addwrp" style={{ marginBottom: "16px" }}>
                                  <Space>
                                    <MinusSquareFilled
                                      className="add"

                                      onClick={(e) =>
                                        removePersonBuyer(outerIndex, outerObj)
                                      }
                                    />
                                  </Space>
                                </div>
                              </Col>
                            )}

                          </Row>
                        </div>
                      ))}
                  </Panel>
                </Collapse> */}

                {state.vendors_email &&
                  state.vendors_email?.map((outerObj, outerIndex) => (
                    <Collapse defaultActiveKey={[outerIndex]} key={outerIndex}>
                      <Panel
                        header={`${outerIndex + 1}. ${outerObj.vendor_name}`}
                        key={outerIndex}
                      >
                        {outerObj?.vendor_persons?.map((person, innerIndex) => (
                          <Row
                            key={`${outerIndex}-${innerIndex}`}
                            className="customcol"
                            gutter={[15]}
                          >
                            <Col
                              xs={24}
                              sm={24}
                              md={12}
                              lg={4}
                              xl={4}
                              className="TextFeild gutter-row"
                            >
                              <Form.Item
                                name={`email${outerIndex}${innerIndex}`}
                                label={innerIndex === 0 ? t("pl_email") : ""}
                              >
                                <Input
                                  className="cust-input"
                                  value={person.email}
                                  onChange={(e) =>
                                    handleChange(
                                      e.target.value,
                                      `email`,
                                      outerIndex,
                                      innerIndex,
                                      outerObj.vendor
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              xs={24}
                              sm={24}
                              md={12}
                              lg={4}
                              xl={4}
                              className="TextFeild gutter-row"
                            >
                              <Form.Item
                                name={`person_name${outerIndex}${innerIndex}`}
                                label={
                                  innerIndex === 0 ? t("pl_personName") : ""
                                }
                              >
                                <Input
                                  className="cust-input"
                                  value={person.person_name}
                                  onChange={(e) =>
                                    handleChange(
                                      e.target.value,
                                      `person_name`,
                                      outerIndex,
                                      innerIndex
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              xs={24}
                              sm={24}
                              md={12}
                              lg={4}
                              xl={4}
                              className="TextFeild gutter-row"
                            >
                              <Form.Item
                                name={`designation${outerIndex}${innerIndex}`}
                                label={
                                  innerIndex === 0 ? t("pl_designation") : ""
                                }
                              >
                                <Input
                                  className="cust-input"
                                  value={person.designation}
                                  onChange={(e) =>
                                    handleChange(
                                      e.target.value,
                                      `designation`,
                                      outerIndex,
                                      innerIndex
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>

                            <Col
                              xs={24}
                              sm={24}
                              md={12}
                              lg={4}
                              xl={4}
                              className="TextFeild gutter-row"
                            >
                              <Form.Item
                                name={`phone_number${outerIndex}${innerIndex}`}
                                pattern={"/^d{12}$/"}
                                rules={[
                                  {
                                    pattern: /^\d{12}$/,
                                    message: <Trans>{t("val_phone")}</Trans>,
                                  },
                                ]}
                                label={
                                  innerIndex === 0 ? t("pl_ContactNo") : ""
                                }
                              >
                                <PhoneInput
                                  className="PhoneSection"
                                  country={"in"}
                                  value={person.phone_number}
                                  onChange={(phone) =>
                                    handleChange(
                                      phone,
                                      `phone_number`,
                                      outerIndex,
                                      innerIndex
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            {innerIndex === 0 ? (
                              <Col
                                xs={24}
                                sm={24}
                                md={12}
                                lg={4}
                                xl={4}
                                className="TextFeild addrowkeyperson"
                              >
                                <div className="addwrp">
                                  <Space>
                                    <PlusSquareFilled
                                      className="add"
                                      onClick={() => addPerson(outerIndex)}
                                    />
                                  </Space>
                                </div>
                              </Col>
                            ) : (
                              <Col
                                xs={24}
                                sm={24}
                                md={12}
                                lg={4}
                                xl={4}
                                className="TextFeild addrowkeyperson"
                                style={{ paddingTop: "0px" }}
                              >
                                <div
                                  className="addwrp"
                                  style={{ marginBottom: "16px" }}
                                >
                                  <Space>
                                    <MinusSquareFilled
                                      className="add"
                                      onClick={() =>
                                        removePerson(outerIndex, innerIndex)
                                      }
                                    />
                                  </Space>
                                </div>
                              </Col>
                            )}
                          </Row>
                        ))}
                      </Panel>
                    </Collapse>
                  ))}
                <div className="FormFooter">
                  <ButtonField
                    type="primary"
                    className="SaveGradiantBtn"
                    // htmlType="Submit"
                    label={t("Previous")}
                    // loading={btnLoading}
                    onClick={() =>
                      navigate(`/request-for-quotation/select-vendor/${rfqId}`)
                    }
                  />
                  <ButtonField
                    type="primary"
                    className="SaveGradiantBtn"
                    htmlType="Submit"
                    label={t("Save & Next")}
                    // loading={btnLoading}
                  />
                  {submitted ? (
                    <>
                      <>
                        {employee && (
                          <ButtonField
                            type="primary"
                            className="SaveGradiantBtn"
                            // htmlType="Submit"
                            label={t("RFQ Release")}
                            // loading={btnLoading}
                            onClick={handleDirectRelease}
                          />
                        )}
                      </>

                      <ButtonField
                        type="primary"
                        className="SaveGradiantBtn w-auto"
                        // htmlType="Submit"
                        label={t("Send RFQ for Approval")}
                        onClick={handleSendRfqApproval}
                        // loading={btnLoading}
                      />
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </>
            </Form>
          </Spin>
        </div>
      </section>
    </>
  );
};

EmailForNotificationRFQ.propTypes = {
  VendorId: PropTypes.number,
  setKeyPersonId: PropTypes.func,
};

export default EmailForNotificationRFQ;
